module.exports = __webpack_public_path__ + "img/LogoKreisSmall.10da1787.png";